import React from "react";
import styles from "./style.module.scss";
import LapsTable from "../../components/VirtualLoops/LapsTable";
import ConfigManager from "../../components/VirtualLoops/ConfigManager";
import VirtualLoopsDataManager from "../../components/DataManagers/VirtualLoopsDataManager";
import Plots from "../../components/VirtualLoops/Plots";
import AuthenticatedLayout from "../../components/Layout/authenticatedLayout";

function VirtualLoopsPage() {
  return (
    <AuthenticatedLayout title={"Virtual Loops"} showJaguarLogo={false}>
      <VirtualLoopsDataManager />
      <div className={styles.container}>
        <LapsTable />
        <Plots />
        <ConfigManager />
      </div>
    </AuthenticatedLayout>
  );
}

export default VirtualLoopsPage;
